import { Card, CardHeader, CardContent, Stack, Typography } from "@mui/material";
import { MemberDTO } from "./data-types";
import logo from './images/ctalogo.jpg';
import emailImg from './images/Email-Password.png';
import googleImg from './images/Google.png';
import fbImg from './images/Facebook.png';
import xImg from './images/X.png';
import Signup from './images/Signup.png';

function maskEmail(email) {
    if (!email || !email.includes('@')) {
        return email; // Return original if it's not a valid email
    }

    const [username, domain] = email.split('@');
    if (username.length <= 2) {
        return email; // Return original if username is too short
    }
    const maskedUsername = username.charAt(0) + '*'.repeat(username.length - 2) + username.charAt(username.length - 1);
    return `${maskedUsername}@${domain}`;
}

// const bgStyle = {
//     background: 'linear-gradient(154.04deg, #1743A6 41.41%, #9719B1 82.72%, #AC1BB9 95.9%)',
//     backgroundRepeat: 'no-repeat',
//     top: 0,
//     left: 0,
//     width: '100vw',
//     height: '100vh',
//     backgroundSize: 'cover',
//     zIndex: -1,
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center'
// }

export default function Logins({ memberDTO }: { memberDTO: MemberDTO }) {
    console.log('{memberDTO.identities.length}', memberDTO);

    const getLogin = () => {
        let email = false;
        let google = false;
        let fb = false;
        let x = false;
        memberDTO.identities.filter(x => x.SignInType === 'federated' || x.SignInType === 'emailAddress').forEach(i => {
            if (i.SignInType == 'emailAddress')
                email = true;
            else if (i.Issuer === 'google.com')
                google = true;
            else if (i.Issuer === 'facebook.com')
                fb = true;
            else if (i.Issuer === 'twitter.com')
                x = true;
        });
        return email ? 'email' : google ? 'google' : fb ? 'fb' : x ? 'x' : '';
    }

    const getMessageFragment = () => {
        const login = getLogin();
        const s = '';
        if (login === 'email') {
            const email = memberDTO.identities.find(x => x.SignInType === 'emailAddress').IssuerAssignedId;
            return `with ${maskEmail(email)}`;
        } else if (login === 'google')
            return `with ${maskEmail(memberDTO.emailAddress)} through Google`;
        else if (login === 'fb')
            return `with ${maskEmail(memberDTO.emailAddress)} through Facebook`;
        else if (login === 'x')
            return `with ${maskEmail(memberDTO.emailAddress)} through X`;
        else
            return 'Unknown'
    }

    const loginMethod = getLogin();
    const imgStyle = { width: '100%', height: 'auto' };

    return (
        <Card sx={{ width: 1 }} style={{ paddingLeft: 40, paddingRight: 40, boxSizing: 'border-box' }} >
            <CardHeader
                title={<img src={logo} className="App-logo" alt="logo" />}
            />
            <CardContent>
                <Stack spacing={2}  >
                    <a href="#" onClick={_ => window.close()}>&larr;Close and return to the sign-in page</a>
                    {memberDTO.isAccountRegistered ?
                        <>
                            <Typography>
                                You previously signed in {getMessageFragment()}. Please return to the sign in page and use the sign-in method highlighted below.
                            </Typography>
                            <Stack spacing={1}  >
                                {loginMethod === 'email' ? <img src={emailImg} style={imgStyle} alt="Email Login" /> :
                                    loginMethod === 'google' ? <img src={googleImg} style={imgStyle} alt="Google Login" /> :
                                        loginMethod === 'fb' ? <img src={fbImg} style={imgStyle} alt="Facebook Login" /> :
                                            loginMethod === 'x' ? <img src={xImg} style={imgStyle} alt="X Login" /> :
                                                loginMethod === '' ? <Typography ></Typography> : <Typography >Not Found</Typography>
                                }
                            </Stack>
                        </> :
                        <>
                            <Typography>Membership verified but please return to the sign in page and click <b>"Sign Up Now"</b> to create your login to access members-only content on CTA websites!</Typography>
                            <img src={Signup} style={imgStyle} alt="Sign up now" />
                        </>
                    }
                </Stack>
            </CardContent>
        </Card>
    );
}

